import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { metaTrack } from "./metaPixel";

export default function MetaRoutePageViews() {
  const location = useLocation();
  const first = useRef(true);
  const lastUrl = useRef("");

  useEffect(() => {
    const url = location.pathname + location.search + location.hash;
    if (first.current) {
      first.current = false;
      lastUrl.current = url;
      return;
    }
    if (url === lastUrl.current) return;
    lastUrl.current = url;
    metaTrack("PageView");
  }, [location.pathname, location.search, location.hash]);

  return null;
}
